var _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPokeball({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, " Svg Vector Icons : http://www.onlinewebfonts.com/icon ")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M500,10.1c-270.5,0-490,219.4-490,489.8c0,270.5,219.5,490,490,490c270.5,0,490-219.5,490-490C990,229.4,770.5,10.1,500,10.1z M500,353.3c81,0,146.8,65.6,146.8,146.6c0,81-65.8,146.8-146.8,146.8c-81,0-146.8-65.8-146.8-146.8C353.2,418.9,419,353.3,500,353.3z M84.7,531.4H290c15.2,102.3,103.5,180.7,210,180.7s194.8-78.4,210-180.7h205.3c-16.2,215.2-196,385.1-415.3,385.1C280.7,916.5,100.8,746.7,84.7,531.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPokeball);
export default __webpack_public_path__ + "static/media/pokeball.3fb2f50e0bb573119c872cd6f8b0407e.svg";
export { ForwardRef as ReactComponent };